import type { JSX } from "react";

import type { BreadcrumbProps } from "./Breadcrumb.types";

export function Breadcrumb({
  children,
  className,
  "aria-label": ariaLabel = "breadcrumb",
}: BreadcrumbProps): JSX.Element {
  return (
    <nav data-slot="breadcrumb" aria-label={ariaLabel} className={className}>
      {children}
    </nav>
  );
}
